import React from 'react';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Hero from 'views/for-engineers/Hero';
import Benefits from 'views/for-engineers/Benefits';
import HappyTeams from 'views/for-engineers/HappyTeams';
import Pipeline from 'views/for-engineers/Pipeline';
import EndingCta from 'components/EndingCta';
import TrustedBy from 'components/TrustedBy';
import Security from 'components/Security';

const ForEngineers = () => (
  <Layout>
    <Hero />
    <TrustedBy />
    <Benefits />
    <Security />
    <HappyTeams />
    <Pipeline />
    <EndingCta />
  </Layout>
);

export const Head = () => (
  <SEO
    title="Mudstack for engineers"
    description="Build better art pipelines. Revolutionize the way your game dev team manages and interacts with digital assets."
  />
);

export default ForEngineers;
